module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2026.95b5b9f8.png";